import Section from './Section';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@tanstack/react-query';
import { fetchFilters } from '@/lib/api';
import List from '../List/List';
import FilterOptionsUnavailable from './FilterOptionsUnavailable';

const GameProvider = ({
  value,
  onChange,
  mode = 'light',
}: {
  value: string[];
  onChange: (values: string[]) => void;
  mode?: 'light' | 'dark';
}) => {
  const { data, isPending, isError } = useQuery({
    queryKey: ['filters'],
    queryFn: fetchFilters,
  });
  const items =
    data?.game_providers.map((item) => ({
      id: item,
      label: item,
      value: item,
    })) || [];

  return (
    <Section
      title={
        <FormattedMessage
          id="gameProvider"
          defaultMessage="Game Studio"
        />
      }
      aria-label="Game studio filter"
      mode={mode}
      defaultOpen={value.length > 0}
    >
      {isError && !data ? (
        <FilterOptionsUnavailable />
      ) : (
        <List
          loading={isPending}
          items={items}
          values={value}
          onChange={(values) => onChange(values as string[])}
          mode={mode}
        />
      )}
    </Section>
  );
};

export default GameProvider;

